import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import Footer from './Footer';
import { verifyChangeEmailToken } from '../store/actions/auth';

class ChangeEmailVerification extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isValid: false,
			message: '',
		};
		this.verifyToken();
	}

	verifyToken = () => {
		const {
			verifyChangeEmailToken,
			currentUser: { isAuthenticated },
			match: {
				params: { changeEmailVerificationToken = '' },
			},
		} = this.props;
		if (isAuthenticated) {
			this.setState({ isValid: false });
			return;
		}
		verifyChangeEmailToken(changeEmailVerificationToken)
			.then(response =>
				this.setState({ isValid: true, message: response.data.message })
			)
			.catch(() => this.setState({ isValid: false }));
	};

	renderMessage() {
		const { isValid, message } = this.state;
		if (isValid) {
			return (
				<div className="row">
					<div className="col-md-12 contact-form text-center">
						<h3>{message}</h3>
					</div>
				</div>
			);
		} else {
			return (
				<div className="text-center">
					<h3>Invalid Token</h3>
					<p>Please try again with new link.</p>
				</div>
			);
		}
	}

	render() {
		const {
			currentUser: { isAuthenticated },
		} = this.props;
		return (
			<Fragment>
				<Header {...this.props} />
				<div
					className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed"
					style={{ height: 'calc(100vh - 219px)' }}
				>
					<div className="container">
						<div className="row">
							<div className="content-box video-popup">
								<div className="col-md-10 col-md-offset-1">
									<div className="content text-center">
										<h1>Change Email Verification</h1>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div id="contact" className="contact-us-area">
						<div className="container">
							{isAuthenticated ? (
								<div className="text-center">
									<h3>Already Logged In!</h3>
									<p>
										It seems you are already logged in. Please log out first and
										try again.
									</p>
								</div>
							) : (
								this.renderMessage()
							)}
						</div>
					</div>
				</div>
				<Footer {...this.props} />
			</Fragment>
		);
	}
}

export default connect(null, { verifyChangeEmailToken })(
	ChangeEmailVerification
);



// WEBPACK FOOTER //
// ./src/components/ChangeEmailVerification.js